/* tslint:disable */
/* eslint-disable */
/**
 * Geckosoft.Pim.Api | rt-v0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AiTextTranslationNotificationPayloadAiGenerationsInner } from './AiTextTranslationNotificationPayloadAiGenerationsInner';
import {
    AiTextTranslationNotificationPayloadAiGenerationsInnerFromJSON,
    AiTextTranslationNotificationPayloadAiGenerationsInnerFromJSONTyped,
    AiTextTranslationNotificationPayloadAiGenerationsInnerToJSON,
    AiTextTranslationNotificationPayloadAiGenerationsInnerToJSONTyped,
} from './AiTextTranslationNotificationPayloadAiGenerationsInner';

/**
 * A creation, update or deletion of AI text translations of the company.
 * @export
 * @interface AiTextTranslationNotificationPayload
 */
export interface AiTextTranslationNotificationPayload {
    /**
     * What happened to the AI text translations.
     * @type {AiTextTranslationNotificationPayloadOperationEnum}
     * @memberof AiTextTranslationNotificationPayload
     */
    operation: AiTextTranslationNotificationPayloadOperationEnum;
    /**
     * The AI text translations that were created, updated or deleted.
     * @type {Array<AiTextTranslationNotificationPayloadAiGenerationsInner>}
     * @memberof AiTextTranslationNotificationPayload
     */
    aiGenerations: Array<AiTextTranslationNotificationPayloadAiGenerationsInner>;
}


/**
 * @export
 */
export const AiTextTranslationNotificationPayloadOperationEnum = {
    Creation: 'creation',
    Update: 'update',
    Deletion: 'deletion'
} as const;
export type AiTextTranslationNotificationPayloadOperationEnum = typeof AiTextTranslationNotificationPayloadOperationEnum[keyof typeof AiTextTranslationNotificationPayloadOperationEnum];


/**
 * Check if a given object implements the AiTextTranslationNotificationPayload interface.
 */
export function instanceOfAiTextTranslationNotificationPayload(value: object): value is AiTextTranslationNotificationPayload {
    if (!('operation' in value) || value['operation'] === undefined) return false;
    if (!('aiGenerations' in value) || value['aiGenerations'] === undefined) return false;
    return true;
}

export function AiTextTranslationNotificationPayloadFromJSON(json: any): AiTextTranslationNotificationPayload {
    return AiTextTranslationNotificationPayloadFromJSONTyped(json, false);
}

export function AiTextTranslationNotificationPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiTextTranslationNotificationPayload {
    if (json == null) {
        return json;
    }
    return {
        
        'operation': json['operation'],
        'aiGenerations': ((json['aiGenerations'] as Array<any>).map(AiTextTranslationNotificationPayloadAiGenerationsInnerFromJSON)),
    };
}

export function AiTextTranslationNotificationPayloadToJSON(json: any): AiTextTranslationNotificationPayload {
    return AiTextTranslationNotificationPayloadToJSONTyped(json, false);
}

export function AiTextTranslationNotificationPayloadToJSONTyped(value?: AiTextTranslationNotificationPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operation': value['operation'],
        'aiGenerations': ((value['aiGenerations'] as Array<any>).map(AiTextTranslationNotificationPayloadAiGenerationsInnerToJSON)),
    };
}

